import React from "react";

import { useSelector } from "react-redux";

import { getContextByModalType } from "selectors";

import { useCloseStateDialog } from "hooks";

export function StateModalAdapter(props) {
  const { hash, component: ModalComponent, componentProps = null } = props;
  const onClose = useCloseStateDialog(hash);

  const context = useSelector(getContextByModalType(hash)) || {};
  const { isOpen } = context;

  if (!isOpen) {
    return null;
  }

  return <ModalComponent onClose={onClose} {...componentProps} />;
}
